import { set } from '../../../utils/vuex'

export default {
  setUser: set('user'),
  setUsers: set('users'),
  setList: set('list'),
  pushUser (state, payload) {
    state.users = [...state.users, payload]
  },
  updateName (state, payload) {
    state.users = state.users.map(elem => {
      if (elem.id !== payload.id) {
        return elem
      } else {
        return {
          ...elem,
          name: payload.name
        }
      }
    })
  },
  deleteUser (state, payload) {
    state.users = state.users.filter(elem => elem.id !== payload)
  }
}
